export default __webpack_public_path__ + "static/media/ensIconLogoWhite.a7096518.svg";